import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DemandeRecrutementService } from 'src/app/core/services/demande-recrutement.service';
import localeFr from '@angular/common/locales/fr';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { FileService } from 'src/app/core/services/file.service';
import { DemandeType } from '@models/enums';
import { map, take, takeUntil } from 'rxjs/operators';
import { DemandeValidation } from '@models/api/responses';
import { PagedResultDTO } from '@models/shared';
import { FilterParams } from '@models/api/requests';
import { ValidationDemandesService } from 'src/app/core/services/validation-demandes.service';
import { DemandeStatusService } from 'src/app/core/services/demande-status.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { DemandesService } from 'src/app/core/services/demandes.service';
import { FileUtilsService } from 'src/app/core/services/file-utils.service';
import { RoleService } from 'src/app/core/services/role.service';
import { Role } from '@models/enums';
import { FilesAttachmentModalComponent } from 'src/app/shared/files-attachment-modal/files-attachment-modal.component';
import { FileAttachment } from '@models/shared';
import { DemandeRenouvellementService } from 'src/app/core/services/demande-renouvellement.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { FilterControlsComponent } from './filter-controls/filter-controls.component';
import { formatDetenteurPoste } from './consultation.utils';
import { MatRadioModule, MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToastrDownloadService } from 'src/app/services/toastr-download.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { StatusAvis } from '@models/enums';

registerLocaleData(localeFr);
@Component({
    selector: 'app-consultation',
    imports: [
        CommonModule,
        ArianeNavComponent,
        MatDatepickerModule,
        MatSelectModule,
        MatDividerModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTabsModule,
        MatInputModule,
        MatButtonModule,
        DataTableOptimizedComponent,
        MatExpansionModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        FilterControlsComponent,
        MatRadioModule,
        FormsModule,
        MatAutocompleteModule
    ],
    templateUrl: './consultation.component.html',
    styleUrls: ['./consultation.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: { color: 'primary' }
        }
    ]
})
export class ConsultationComponent implements OnInit, OnDestroy {
  @ViewChild('dataTableRecrutement') dataTableRecrutement: DataTableOptimizedComponent;
  @ViewChild('dataTableRenouvellement') dataTableRenouvellement: DataTableOptimizedComponent;
  @ViewChild('dataTableRenouvellementVueGlobale') dataTableRenouvellementVueGlobale: DataTableOptimizedComponent;
  @ViewChild('dataTableRecrutementVueGlobale') dataTableRecrutementVueGlobale: DataTableOptimizedComponent;
  @ViewChildren(FilterControlsComponent) filterControls: QueryList<FilterControlsComponent>;

  dataSource!: MatTableDataSource<any>;

  arianeLabel: string = 'Consultation des demandes';
  arianeIcon: string = 'quick_reference_all';
  arianeList = [
    {
      label: 'Consultation des demandes',
      url: '/pama/consultation'
    }
  ];
  filteredOptions: any = [];
  agentsList: any[] = [];
  filtreActifVueGlobal: boolean = true;

  filterSubject = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    typeDemande: DemandeType.Recrutement,
    dateCreationStart: null,
    dateCreationEnd: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouveleId: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });

  userRoles: Role[] = [];
  isAdmin: boolean = false;
  pipe = new DatePipe(/*'fr-FR'*/ 'en-US');
  filtreDemandeActif: boolean = false;
  filtrer_libelle$: Observable<any> = of('Filtrer');
  isTabRecrutement: boolean = true;
  panelOpenStateRecrutement: boolean = false;
  panelOpenStateRenouvellement: boolean = false;
  panelOpenStateVueGlobale: boolean = false;
  showSpinner = false;
  selectedTabIndex: number = 0;
  form_filtre_demande_refusee: FormGroup;
  isRecrutementActive: boolean = true;
  isRenouvellementActive: boolean = true;
  isRenouvellementActive$: Observable<any> = of(true);
  list: any[] = [];
  dataJSON: any[] = [];
  dataRecrutement: any[] = [];
  dataRenouvellement: any[] = [];
  length: number;
  private readonly destroy$ = new Subject<void>();

  recrutementDisplayedColumns: string[] = [
    'Emetteur de la demande',
    'Type de recrutement',
    'Direction',
    'Service',
    'N° de poste',
    'Détenteur du poste',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesDisplayedColumns: string[] = [
    'Emetteur de la demande',
    'Type de renouvellement',
    'Direction',
    'Service',
    'N° de poste',
    'Agent à renouveler',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesCellStyleCss: any = {
    Statut: { 'text-align': 'center' },
    'Date création': { 'text-align': 'center' }
  };

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly demandeRecrutementService: DemandeRecrutementService,
    private readonly demandeRenouvellementService: DemandeRenouvellementService,
    public dialog: MatDialog,
    private readonly fileService: FileService,
    private readonly demandeStatusService: DemandeStatusService,
    private readonly snackBar: MatSnackBar,
    private readonly demandesService: DemandesService,
    private readonly fileUtils: FileUtilsService,
    private readonly roleService: RoleService,
    private readonly validationDemandesService: ValidationDemandesService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly router: Router,
    private readonly toastrService: ToastrService,
    private readonly toastrDownloadService: ToastrDownloadService,
    private readonly excelService: ExcelService
  ) {}

  ngOnInit(): void {
    this.cdRef.detectChanges();

    this.form_filtre_demande_refusee = this.formBuilder.group({
      emetteur: [''],
      dateCreation: [''],
      dateCreationStart: [''],
      dateCreationEnd: [''],
      statut: ['']
    });

    this.filtrer_libelle$ = this.filterSubject.pipe(
      map((filters) => {
        const activeFilters = [
          filters?.emetteur,
          filters?.dateCreationStart && filters?.dateCreationEnd,
          filters?.statut,
          filters?.direction,
          filters?.serviceFonctionnel,
          filters?.numeroPoste,
          filters?.agentRenouveleId || filters?.agentRenouvele,
          filters?.typeRecrutement,
          filters?.typeRenouvellement
        ].filter(Boolean).length;

        return activeFilters > 0 ? `Filtrer (${activeFilters})` : 'Filtrer';
      })
    );

    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.userRoles = roles as Role[];
        this.isAdmin = this.userRoles.some((role) => role === Role.PAMA_ADMIN);
      });
  }
  ngAfterViewInit() {
    this.isRenouvellementActive == false;
    this.isRenouvellementActive$ = of(false);
  }
  radioChange(event: any) {
    this.isRecrutementActive = event.value;
    this.isTabRecrutement = event.value;
    this.isRenouvellementActive = event.value == true ? false : true;
    if (event.value == true) {
      this.isRenouvellementActive$ = of(false);
    } else {
      this.isRenouvellementActive$ = of(true);
    }
    this.resetFilter();
    this.cdRef.detectChanges();
  }

  getDemandesRenouvellementRefusees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesRefusees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };
  getDemandesRecrutementRefusees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesRefusees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  clearAllSelections() {
    if (this.dataTableRecrutement) {
      this.dataTableRecrutement.clearSelection();
    }
    if (this.dataTableRenouvellement) {
      this.dataTableRenouvellement.clearSelection();
    }
    if (this.dataTableRecrutementVueGlobale) {
      this.dataTableRecrutementVueGlobale.clearSelection();
    }
    if (this.dataTableRenouvellementVueGlobale) {
      this.dataTableRenouvellementVueGlobale.clearSelection();
    }
  }
  onTabChange(event: any) {
    let indexTab = event.index;

    if (indexTab === 0 || indexTab === 2) {
      this.isTabRecrutement = true;
      this.isRecrutementActive = true;
    } else if (indexTab === 1) {
      this.isTabRecrutement = false;
      this.isRecrutementActive = false;
    }
    this.resetFilter();

    this.clearAllSelections();

    this.cdRef.detectChanges();
  }
  resetFilter() {
    //this.form_filtre_demande_refusee.reset();
    this.filterControls.forEach((element) => {
      element.resetForm();
    });
    this.filterSubject.next({
      emetteur: null,
      typeDemande: this.isRecrutementActive ? DemandeType.Recrutement : DemandeType.Renouvellement,
      dateCreationStart: null,
      dateCreationEnd: null,
      statut: null,
      direction: null,
      serviceFonctionnel: null,
      numeroPoste: null,
      agentRenouveleId: null,
      typeRecrutement: null,
      typeRenouvellement: null
    });
    this.cdRef.detectChanges();
  }
  viewPdfDtails(element: DemandeValidation) {
    const dialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: [{ id: element.id, type: DemandeType[element.typeDemande as keyof typeof DemandeType] }],
        filename: `demande-${element.id}`,
        action: 'view'
      }
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.dataTableRecrutement?.refresh();
        }
      });
  }

  onFilterApplied(formValues: any) {
    const startDate = formValues.dateCreation ? this.pipe.transform(formValues.dateCreation, 'yyyy-MM-ddT00:00:00') : null;

    const endDate = formValues.dateCreation
      ? this.pipe.transform(
          new Date(new Date(formValues.dateCreation).setDate(new Date(formValues.dateCreation).getDate() + 1)),
          'yyyy-MM-ddT00:00:00'
        )
      : null;
    const typeDemande = this.isRecrutementActive ? DemandeType.Recrutement : DemandeType.Renouvellement;

    const filterParams: FilterParams = {
      emetteur:
        formValues?.emetteur?.nom && formValues?.emetteur?.prenom ? `${formValues.emetteur?.nom} ${formValues.emetteur?.prenom}` : '',
      typeDemande: typeDemande,
      //dateCreation: formValues.dateCreation || null,
      dateCreationStart: startDate,
      dateCreationEnd: endDate,
      statut: formValues.statut ?? null,
      direction: formValues?.direction?.libelle ?? null,
      serviceFonctionnel: formValues?.serviceFonctionnel?.libelle ?? null,
      numeroPoste: formValues?.numeroPoste?.numero ?? null,
      agentRenouveleId: (this.isRecrutementActive ? formValues?.detenteurPoste?.id : formValues?.agentRenouvele?.id) ?? null,
      agentRenouvele: this.getAgentRenouveleLibelle(
        this.isRecrutementActive ? formValues?.detenteurPoste : formValues?.agentRenouvele
      ),
      typeRecrutement: formValues?.typeRecrutement?.libelle ?? null,
      typeRenouvellement: formValues?.typeRenouvellement?.libelle ?? null
    };

    this.filterSubject.next(filterParams);
  }

  private getAgentRenouveleLibelle(agent: { id?: string | null; nom?: string | null; prenom?: string | null } | null | undefined): string | null {
    if (agent?.id) {
      return null;
    }

    return [agent?.nom, agent?.prenom].filter(Boolean).join(' ').trim() || null;
  }

  getDemandesRecrutementData = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getAllDemandes(pageIndex, pageSize, filter).pipe(
      map((response) => {
        console.log(' Réponse brute API:', response);
        this.length = response.totalRecords;
        this.dataRecrutement = response.results;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  getDemandesRenouvellementData = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getAllDemandes(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.length = response.totalRecords;
        this.dataRenouvellement = response.results;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  transformData_demandes(data: any[]): any[] {
    return data.map((demande) => ({
      'Emetteur de la demande': demande.emetteur,
      'Type de recrutement': demande.typeDemande === 'Recrutement' ? demande.libelleDetailType || demande.typeDemande : undefined,
      'Type de renouvellement': demande.typeDemande === 'Renouvellement' ? demande.libelleDetailType || demande.typeDemande : undefined,
      Direction: demande.direction ?? '',
      Service: demande.serviceFonctionnel ?? '',
      'N° de poste': demande.numeroPoste ?? '',
      'Détenteur du poste': formatDetenteurPoste(demande),
      'Agent à renouveler': demande.agentRenouvele ?? '',
      'Date de création': demande.dateCreation ? this.pipe.transform(demande.dateCreation, 'dd/MM/yyyy HH:mm') : 'Date non définie',
      Statut: {
        text: this.demandeStatusService.getStatusText(demande.statut),
        class: this.demandeStatusService.getStatusClass(demande.statut)
      },
      typeDemande: demande.typeDemande,
      id: demande.id,
      view_hidden: false,
      view_disabled: false,
      delete_hidden: !this.demandeStatusService.isDeleteable(demande.statut),
      edit_hidden: !this.demandeStatusService.isEditable(demande.statut),
      download_hidden: false,
      downloadPJ_hidden: false,
      statut: demande.statut,
      actionOrder: ['edit', 'delete', 'download', 'downloadPJ', 'detail']
    }));
  }

  transformData_demandes_export(data: any[], typeDemande: any = null): any[] {
    return data.map((demande) => {
      const emetteur =
        typeof demande.emetteur === 'object'
          ? `${demande.emetteur.prenom ?? ''} ${demande.emetteur.nom ?? ''}`.trim()
          : (demande.emetteur?.trim?.() ?? 'Inconnu');
      const typeColumn =
        typeDemande === 'renouvellement'
          ? { 'Type de renouvellement': demande.libelleDetailType || demande.typeDemande }
          : { 'Type de recrutement': demande.libelleDetailType || demande.typeDemande };

      let ligne: any = {
        'Emetteur de la demande': emetteur,
        ...typeColumn,
        Direction: demande.direction ?? '',
        Service: demande.serviceFonctionnel ?? '',
        'N° de poste': demande.numeroPoste ?? '',
        ...(typeDemande === 'renouvellement' ? {} : { 'Détenteur du poste': formatDetenteurPoste(demande) })
      };

      if (typeDemande == 'renouvellement') {
        ligne['Agent à renouveler'] = demande.agentRenouvele ?? '';
      }

      ligne = {
        ...ligne,
        ...{
          'Date de création': demande.dateCreation ? this.pipe.transform(demande.dateCreation, 'dd/MM/yyyy HH:mm') : 'Date non définie',
          Statut: this.demandeStatusService.getStatusText(demande.statut)
        }
      };

      return ligne;
    });
  }

  togglePanelRecrutement() {
    this.panelOpenStateRecrutement = !this.panelOpenStateRecrutement;
    this.panelOpenStateRenouvellement = false;
  }

  togglePanelRenouvellement() {
    this.panelOpenStateRenouvellement = !this.panelOpenStateRenouvellement;
    this.panelOpenStateRecrutement = false;
  }
  togglePanelVueGlobale() {
    this.panelOpenStateVueGlobale = !this.panelOpenStateVueGlobale;
  }

  exporterEnMasseRecrutement() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    let selectedIds = this.dataTableRecrutement.getSelectedItems().map((d) => String(d.id));
    if (selectedIds.length > 0) {
      const rawSelectedDemandes = this.dataRecrutement.filter((d) => selectedIds.includes(String(d.id)));
      let _data_export = this.transformData_demandes_export(rawSelectedDemandes);
      this.convertExcel(_data_export, 'export_demandes_recrutement_consultation');

      setTimeout(() => {
        this.toastrDownloadService.downloadSuccess();
      }, 2000);

      this.snackBar.open('Export réussi !', 'Fermer', {
        duration: 4000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
    } else {
      this.validationDemandesService
        .getAllDemandes(0, this.length, { typeDemande: 'Recrutement' })
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            if (result) {
              let _data_export = this.transformData_demandes_export(result.results);
              this.convertExcel(_data_export, 'export_demandes_recrutement_consultation');

              setTimeout(() => {
                this.toastrDownloadService.downloadSuccess();
              }, 2000);

              this.snackBar.open('Export réussi !', 'Fermer', {
                duration: 4000,
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
          },
          error: (error) => {
            this.toastrService.clear();
            this.toastrDownloadService.removeToast();

            this.snackBar.open("Erreur lors de l'export", 'Fermer', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        });
    }
  }

  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}_${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }

  exporterEnMasseRenouvellement() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    let selectedIds = this.dataTableRenouvellement.getSelectedItems().map((d) => String(d.id));
    if (selectedIds.length > 0) {
      const rawSelectedDemandes = this.dataRenouvellement.filter((d) => selectedIds.includes(String(d.id)));
      let _data_export = this.transformData_demandes_export(rawSelectedDemandes, 'renouvellement');
      this.convertExcel(_data_export, 'export_demandes_renouvellement_consultation');

      setTimeout(() => {
        this.toastrDownloadService.downloadSuccess();
      }, 2000);

      this.snackBar.open('Export réussi !', 'Fermer', {
        duration: 4000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
    } else {
      this.validationDemandesService
        .getAllDemandes(0, this.length, { typeDemande: 'Renouvellement' })
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            if (result) {
              let _data_export = this.transformData_demandes_export(result.results, 'renouvellement');
              this.convertExcel(_data_export, 'export_demandes_renouvellement_consultation');

              setTimeout(() => {
                this.toastrDownloadService.downloadSuccess();
              }, 2000);

              this.snackBar.open('Export réussi !', 'Fermer', {
                duration: 4000,
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
          },
          error: (error) => {
            this.toastrService.clear();
            this.toastrDownloadService.removeToast();

            this.snackBar.open("Erreur lors de l'export", 'Fermer', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        });
    }
  }

  /**
   * Filters demands based on their validation status
   * @param demands List of demands to filter
   * @returns Filtered list of demands that can be modified or deleted
   */
  filterDemandesByStatus(demands: any[]): any[] {
    return demands.filter((demande) => demande.statut === StatusAvis.A_VALIDER || demande.statut === StatusAvis.A_VALIDER_N0);
  }

  modifierEnMasseRecrutement() {
    let selectedDemandes = this.dataTableRecrutement.getSelectedItems();

    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à modifier', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }
    // Filter only demands with status "A_VALIDER"
    let validDemandes = this.filterDemandesByStatus(selectedDemandes);
    if (validDemandes.length === 0) {
      this.snackBar.open("Aucune demande modifiable n'a été sélectionnée", 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const pdfDialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: validDemandes.map((demande) => ({
          id: demande.id,
          type: demande.typeDemande
        })),
        filename: 'demandes-multiples',
        action: 'edit'
      }
    });

    pdfDialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.dataTableRecrutement.clearSelection();
        if (result === 'refresh') {
          this.dataTableRecrutement.refresh();
        }
      });
  }
  modifierEnMasseRenouvellement() {
    let selectedDemandes = this.dataTableRenouvellement.getSelectedItems();

    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à modifier', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }
    // Filter only demands with status "A_VALIDER"
    let validDemandes = this.filterDemandesByStatus(selectedDemandes);
    if (validDemandes.length === 0) {
      this.snackBar.open("Aucune demande modifiable n'a été sélectionnée", 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const pdfDialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: validDemandes.map((demande) => ({
          id: demande.id,
          type: demande.typeDemande
        })),
        filename: 'demandes-multiples',
        action: 'edit'
      }
    });

    pdfDialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.dataTableRenouvellement.clearSelection();
        if (result === 'refresh') {
          this.dataTableRenouvellement.refresh();
        }
      });
  }

  supprimerEnMasseRecrutement() {
    let selectedDemandes = this.dataTableRecrutement.getSelectedItems();
    selectedDemandes = this.filterDemandesByStatus(selectedDemandes);
    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à supprimer', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const recrutementDemandes = selectedDemandes.filter((demande) => demande.typeDemande == DemandeType.Recrutement);
    const renouvellementDemandes = selectedDemandes.filter((demande) => demande.typeDemande == DemandeType.Renouvellement);

    const totalDemandes = recrutementDemandes.length + renouvellementDemandes.length;
    let confirmationMessage = `Voulez-vous supprimer ${totalDemandes} demande${totalDemandes > 1 ? 's' : ''} ?`;

    const validationModalRef = this.dialog.open(ValidationModalComponent, {
      width: '400px',
      data: {
        title: 'Suppression en masse',
        content: confirmationMessage,
        showCancelButton: true
      }
    });

    validationModalRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          const requestBody = {
            Recrutement: recrutementDemandes.map((demande) => demande.id),
            Renouvellement: renouvellementDemandes.map((demande) => demande.id)
          };

          this.demandesService.deleteDemandes(requestBody).subscribe({
            next: () => {
              this.snackBar.open('Les demandes ont été supprimées avec succès', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['success-snackbar']
              });
              this.dataTableRecrutement.clearSelection();
              this.dataTableRecrutement.refresh();
            },
            error: (error) => {
              this.snackBar.open('Une erreur est survenue lors de la suppression des demandes', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['error-snackbar']
              });
              console.error('Error deleting requests:', error);
            }
          });
        }
      });
  }
  supprimerEnMasseRenouvellement() {
    let selectedDemandes = this.dataTableRenouvellement.getSelectedItems();
    selectedDemandes = this.filterDemandesByStatus(selectedDemandes);
    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à supprimer', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const recrutementDemandes = selectedDemandes.filter((demande) => demande.typeDemande == DemandeType.Recrutement);
    const renouvellementDemandes = selectedDemandes.filter((demande) => demande.typeDemande == DemandeType.Renouvellement);

    const totalDemandes = recrutementDemandes.length + renouvellementDemandes.length;
    let confirmationMessage = `Voulez-vous supprimer ${totalDemandes} demande${totalDemandes > 1 ? 's' : ''} ?`;

    const validationModalRef = this.dialog.open(ValidationModalComponent, {
      width: '400px',
      data: {
        title: 'Suppression en masse',
        content: confirmationMessage,
        showCancelButton: true
      }
    });

    validationModalRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          const requestBody = {
            Recrutement: recrutementDemandes.map((demande) => demande.id),
            Renouvellement: renouvellementDemandes.map((demande) => demande.id)
          };

          this.demandesService.deleteDemandes(requestBody).subscribe({
            next: () => {
              this.snackBar.open('Les demandes ont été supprimées avec succès', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['success-snackbar']
              });
              this.dataTableRenouvellement.clearSelection();
              this.dataTableRenouvellement.refresh();
            },
            error: (error) => {
              this.snackBar.open('Une erreur est survenue lors de la suppression des demandes', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['error-snackbar']
              });
              console.error('Error deleting requests:', error);
            }
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  editDemande(demande: any) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: demande.id, type: demande.typeDemande }],
          filename: `demande-${demande.id}`,
          action: 'edit'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.dataTableRenouvellement.clearSelection();
        this.dataTableRecrutement.clearSelection();
        if (result === 'refresh') {
          this.dataTableRecrutement.refresh();
          this.dataTableRenouvellement.refresh();
        }
      });
  }

  deleteDemande(demande: any) {
    this.dialog
      .open(ValidationModalComponent, {
        width: '400px',
        data: {
          title: 'Suppression',
          content: 'Voulez-vous supprimer cette demande ?',
          showCancelButton: true
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          const deleteObservable =
            demande.typeDemande === 'Recrutement'
              ? this.demandeRecrutementService.deleteDemandesRecrutement(demande.id)
              : this.demandeRenouvellementService.deleteDemandesRenouvellement(demande.id);

          deleteObservable.pipe(take(1)).subscribe({
            next: () => {
              this.snackBar.open('Demande supprimée avec succès', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['success-snackbar']
              });
              if (demande.typeDemande === 'Recrutement') {
                this.dataTableRecrutement.clearSelection();
                this.dataTableRecrutement.refresh();
              } else {
                this.dataTableRenouvellement.clearSelection();
                this.dataTableRenouvellement.refresh();
              }
            },
            error: (error: unknown) => {
              this.snackBar.open('Une erreur est survenue lors de la suppression de la demande', 'Fermer', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['error-snackbar']
              });
            }
          });
        }
      });
  }

  downloadDemande(demande: any) {
    if (!demande?.id || !demande?.typeDemande) {
      this.snackBar.open('Informations de demande invalides', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['error-snackbar']
      });
      return;
    }

    this.fileService.getDemandePdf(demande.id, demande.typeDemande).subscribe({
      next: (response: Blob) => {
        const filename = `demande_${demande.typeDemande.toLowerCase()}_${demande.id}.pdf`;
        this.fileUtils.downloadBlob(response, filename);
      },
      error: (error) => {
        console.error('Error downloading PDF:', error);
        this.snackBar.open('Une erreur est survenue lors du téléchargement du fichier', 'Fermer', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['error-snackbar']
        });
      }
    });
  }

  downloadPJ(demande: any) {
    if (!demande?.id || !demande?.typeDemande) {
      this.snackBar.open('ID de demande invalide', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['error-snackbar']
      });
      return;
    }

    let demandeService = demande.typeDemande === 'Recrutement' ? this.demandeRecrutementService : this.demandeRenouvellementService;

    demandeService.getPj(demande.id).subscribe({
      next: (response: FileAttachment[]) => {
        const files = response.map((pj) => ({
          id: pj.id,
          originalFileName: pj.originalFileName,
          fileName: pj.fileName,
          blobattachment: this.fileUtils.base64ToBlob(pj.content)
        }));

        this.dialog.open(FilesAttachmentModalComponent, {
          width: '1000px',
          data: { files }
        });
      },
      error: (error) => {
        console.error('Error fetching PJ:', error);
        this.snackBar.open('Une erreur est survenue lors de la récupération des pièces jointes', 'Fermer', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['error-snackbar']
        });
      }
    });
  }
}
